import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpMethods, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { HelperService } from 'src/app/service/helper.service';
import { Region } from '../../../model/region.model';

@Injectable({
    providedIn: 'root'
})
export class DistrictDataService extends DefaultDataService<SchoolDistrict> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, private helperService: HelperService) {
        super('District', http, httpUrlGenerator);
    }

    override getAll(): Observable<SchoolDistrict[]> {
        const url = this.urlProvider.getUrl(EndPoints.indexSchoolDistricts, undefined, undefined);
        let lstRegion: Region[] = [];
        this.helperService.lstRegion$.subscribe((x) => {
            lstRegion = x;
        });

        return this.http
            .post(
                url,
                { counties: [], regions: lstRegion },
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<SchoolDistrict[]>JSON.parse(res.body['schoolDistricts']));
                })
            );
    }
}
